function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "110.581%",
  y1: "82.707%",
  x2: "10.296%",
  y2: "11.141%",
  id: "table-blob-small_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6E6E6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2F2F2",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1101.2 204.452c-11.786 41.58 66.924 67.551 74.261 31.337 7.337-36.213-62.475-72.917-74.26-31.337z",
  transform: "translate(-1100 -186)",
  fill: "url(#table-blob-small_svg__a)",
  fillRule: "evenodd",
  opacity: 0.32
});

function SvgTableBlobSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 67"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3NiA2NyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IHgxPSIxMTAuNTgxJSIgeTE9IjgyLjcwNyUiIHgyPSIxMC4yOTYlIiB5Mj0iMTEuMTQxJSIgaWQ9ImEiPjxzdG9wIHN0b3AtY29sb3I9IiNFNkU2RTYiIG9mZnNldD0iMCUiLz48c3RvcCBzdG9wLWNvbG9yPSIjRjJGMkYyIiBvZmZzZXQ9IjEwMCUiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cGF0aCBkPSJNMTEwMS4yIDIwNC40NTJjLTExLjc4NiA0MS41OCA2Ni45MjQgNjcuNTUxIDc0LjI2MSAzMS4zMzcgNy4zMzctMzYuMjEzLTYyLjQ3NS03Mi45MTctNzQuMjYtMzEuMzM3eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMDAgLTE4NikiIGZpbGw9InVybCgjYSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgb3BhY2l0eT0iLjMyIi8+PC9zdmc+";
export { SvgTableBlobSmall as ReactComponent };